//扩展vue依赖的文件，防止main.js过大
//vue-form 自定义验证规则
export let vueFormOptions = {
    validators: {
      /*自定义1以上,上可保留小数点后两位*/
      'bid-floor': function (value, attrValue, vnode) {
        return (value >= 1 && /^\d+(\.\d{0,2})?$/.test(value));
      }
    }
  }



// WEBPACK FOOTER //
// ./src/plugins.js